import * as S from './styles.ts';
import { useTypedSelector } from '@/redux/helpers/hooks.ts';
import { Skeleton } from '@template/components';
import Result from '@template/blocks/domain/DomainNamePricingTable/Result';
import THeader from '@template/blocks/domain/DomainNamePricingTable/THeader';

const fakeDomainsAmount = 10;
const fakeDomains = Array(fakeDomainsAmount).fill(0);

const Results = () => {
  const { loaded, prices } = useTypedSelector(
    (state) => state.store.tlds.prices
  );

  if (!loaded) {
    return (
      <S.Table
        as='div'
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 48,
        }}
      >
        {fakeDomains.map((_, i) => (
          <Skeleton key={i} style={{ width: '100%', minHeight: 48, flex: 1 }} />
        ))}
      </S.Table>
    );
  }

  return (
    <S.Table>
      <THeader />
      <tbody>
        {prices.map((result, i) => (
          <Result key={i} tld={result} />
        ))}
      </tbody>
    </S.Table>
  );
};

export default Results;
